import {
  SET_UPLOAD_LISTS,
  SET_IS_UPLOADING,
  UPDATE_UPLOAD_FILE_PERCENTAGE,
  SET_ORDER
} from "../mutation-types";

export default {
  namespaced: true,
  state: () => ({
    uploadLists: [],
    isUploading: false,
    order: false // 订单信息
  }),
  mutations: {
    [SET_UPLOAD_LISTS](state, lists) {
      state.uploadLists = lists;
    },
    [SET_IS_UPLOADING](state, bool) {
      state.isUploading = bool;
    },
    [SET_ORDER](state, orderInfo) {
      state.order = orderInfo;
    },
    // 更新文件进度
    [UPDATE_UPLOAD_FILE_PERCENTAGE](state, { uid, percentage, response }) {
      const index = state.uploadLists.findIndex(item => item.uid === uid);
      state.uploadLists[index].percentage = percentage;
      if (response) state.uploadLists[index].response = response;
    }
  },
  getters: {
    printMode: state => {
      return state.uploadLists.filter(item => item.code === 0).length > 1
        ? "batch"
        : "single";
    }
  }
};
